import { render } from "./DashboardSettingsComponent.vue?vue&type=template&id=2fa08530&scoped=true"
import script from "./DashboardSettingsComponent.vue?vue&type=script&lang=js"
export * from "./DashboardSettingsComponent.vue?vue&type=script&lang=js"

import "./DashboardSettingsComponent.vue?vue&type=style&index=0&id=2fa08530&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fa08530"]])

export default __exports__